"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _OverlayController = _interopRequireDefault(require("../controller/OverlayController"));
var _ModalRenderer = _interopRequireDefault(require("../renderers/ModalRenderer/ModalRenderer"));
var _FlyoutRenderer = _interopRequireDefault(require("../renderers/FlyoutRenderer/FlyoutRenderer"));
var _BottomTrayRenderer = _interopRequireDefault(require("../renderers/BottomTrayRenderer/BottomTrayRenderer"));
var _SideTrayRenderer = _interopRequireDefault(require("../renderers/SideTrayRenderer/SideTrayRenderer"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var initialOverlayState = {
  id: '',
  isShowing: false,
  isTransitioning: false,
  content: null,
  initialFocusId: null,
  focusEnabledRefs: undefined,
  animate: true,
  isClosable: true,
  onCloseCb: null,
  srName: '',
  type: 'modal',
  renderOptions: {}
};
var ANIMATION_DELAY = 200;
var OverlayProvider = /*#__PURE__*/function (_PureComponent) {
  _inherits(OverlayProvider, _PureComponent);
  var _super = _createSuper(OverlayProvider);
  function OverlayProvider(props) {
    var _this;
    _classCallCheck(this, OverlayProvider);
    _this = _super.call(this, props);
    _this.state = {
      renderedModals: []
    };
    _this.handleKeyDown = function (event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        var renderedModals = _this.state.renderedModals;
        var shownOverlay = renderedModals[renderedModals.length - 1];
        if (!shownOverlay || !shownOverlay.isClosable) {
          return;
        }
        _this.removeOverlay(shownOverlay.id);
      }
    };
    _this.getModalById = function (id) {
      var renderedModals = _this.state.renderedModals;
      return renderedModals.find(function (modal) {
        return modal.id === id;
      }) || null;
    };
    _OverlayController["default"].setProvider(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(OverlayProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "setStateForOverlay",
    value: function setStateForOverlay(overlayState) {
      this.setState(function (_ref) {
        var renderedModals = _ref.renderedModals;
        var modalToRender = renderedModals.find(function (modal) {
          return modal.id === overlayState.id;
        });
        if (!modalToRender) {
          var newModals = _objectSpread(_objectSpread({}, initialOverlayState), overlayState);
          return {
            renderedModals: [].concat(_toConsumableArray(renderedModals), [newModals])
          };
        }
        var updatedModals = renderedModals.map(function (modal) {
          return modal.id === overlayState.id ? _objectSpread(_objectSpread({}, modal), overlayState) : modal;
        });
        return {
          renderedModals: updatedModals
        };
      });
    }
  }, {
    key: "removeOverlay",
    value: function removeOverlay(id, source) {
      var _this2 = this;
      var overlay = this.getModalById(id);
      if (!(overlay !== null && overlay !== void 0 && overlay.isShowing)) return;
      if (overlay !== null && overlay !== void 0 && overlay.onCloseCb) {
        overlay.onCloseCb(source);
      }
      this.setStateForOverlay({
        id: id,
        isShowing: false
      }); // delay removal from state to allow animation to finish

      setTimeout(function () {
        _this2.setState(function (_ref2) {
          var renderedModals = _ref2.renderedModals;
          return {
            renderedModals: renderedModals.filter(function (modal) {
              return modal.id !== id;
            })
          };
        });
      }, ANIMATION_DELAY);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.setState({
        renderedModals: []
      });
    }
  }, {
    key: "getModalContainer",
    value: function getModalContainer(rootElement) {
      var _modalContainer;
      var modalContainer = null;
      if (rootElement) {
        modalContainer = document.getElementById(rootElement);
      }
      return (_modalContainer = modalContainer) !== null && _modalContainer !== void 0 ? _modalContainer : document.body;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.state.renderedModals.map(function (config) {
        var id = config.id,
          isShowing = config.isShowing,
          animate = config.animate,
          initialFocusId = config.initialFocusId,
          focusEnabledRefs = config.focusEnabledRefs,
          isClosable = config.isClosable,
          srName = config.srName,
          type = config.type,
          _config$renderOptions = config.renderOptions,
          renderOptions = _config$renderOptions === void 0 ? {} : _config$renderOptions,
          content = config.content,
          header = config.header,
          footer = config.footer,
          rootElement = config.rootElement,
          dataSelectorPrefix = config.dataSelectorPrefix,
          dataAttributes = config.dataAttributes,
          componentName = config.componentName;
        var Renderer = OverlayProvider.renderers[type || 'modal'];
        return /*#__PURE__*/_react["default"].createElement(Renderer, {
          key: id,
          onClose: _this3.removeOverlay.bind(_this3, id),
          hasClosed: _OverlayController["default"].resetModalState,
          animate: animate,
          initialFocusId: initialFocusId,
          focusEnabledRefs: focusEnabledRefs,
          isClosable: isClosable,
          isOpen: isShowing,
          srName: srName,
          appearance: renderOptions === null || renderOptions === void 0 ? void 0 : renderOptions.appearance,
          size: renderOptions === null || renderOptions === void 0 ? void 0 : renderOptions.size,
          side: renderOptions === null || renderOptions === void 0 ? void 0 : renderOptions.side,
          overlayBlur: renderOptions === null || renderOptions === void 0 ? void 0 : renderOptions.overlayBlur,
          enableOverlay: renderOptions === null || renderOptions === void 0 ? void 0 : renderOptions.enableOverlay,
          zIndex: _this3.props.zIndex,
          topOffset: renderOptions === null || renderOptions === void 0 ? void 0 : renderOptions.topOffset,
          fullScreenOnSM: renderOptions === null || renderOptions === void 0 ? void 0 : renderOptions.fullScreenOnSM,
          header: header,
          footer: footer,
          rootElement: _this3.getModalContainer(rootElement),
          id: id,
          dataSelectorPrefix: dataSelectorPrefix,
          dataAttributes: dataAttributes,
          componentName: componentName
        }, content);
      }), this.props.children);
    }
  }]);
  return OverlayProvider;
}(_react.PureComponent);
exports["default"] = OverlayProvider;
OverlayProvider.renderers = {
  modal: _ModalRenderer["default"],
  flyout: _FlyoutRenderer["default"],
  bottomTray: _BottomTrayRenderer["default"],
  sideTray: _SideTrayRenderer["default"]
};
OverlayProvider.defaultProps = {
  zIndex: 100
};
OverlayProvider.displayName = "OverlayProvider";